import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from "../../nest-api";
import {
  RequestApproveDto,
  RequestCancelDto, RequestDeleteDraftDto,
  RequestGetHistoryDto,
  RequestGetScheduleDto, ResponseAddDto, ResponseApproveDto, ResponseCancelDto, ResponseDeleteDraftDto,
  ResponseGetHistoryDto, ResponseGetOnDutyDestinationsDto,
  ResponseGetOnDutyPurposeTypesDto, ResponseGetScheduleDto, RequestApproveCancellationDto
} from "../dto/sf-on-duty.dto";

@Injectable()
export class SfOnDutyApi {

  private service: string = '';
  private model: string = 'SfOnDuty';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getHistory(limit: string | number, page: string | number, payload?: RequestGetHistoryDto): Observable<ResponseGetHistoryDto> {

    const method: string = 'POST';
    const func: string = 'getHistory';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetHistoryDto>(method, url, params, urlParams, body, null, 3 * 60 * 1000);
  }

  public getOnDutyPurposeTypes(): Observable<ResponseGetOnDutyPurposeTypesDto> {

    const method: string = 'GET';
    const func: string = 'getOnDutyPurposeTypes';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetOnDutyPurposeTypesDto>(method, url, func, params, body);
  }

  public getOnDutyDestinations(): Observable<ResponseGetOnDutyDestinationsDto> {

    const method: string = 'GET';
    const func: string = 'getOnDutyDestinations';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetOnDutyDestinationsDto>(method, url, func, params, body);
  }

  public add(payload): Observable<ResponseAddDto> {

    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public saveDraft(payload): Observable<any> {

    const method: string = 'POST';
    const func: string = 'saveDraft';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public getSchedule(payload: RequestGetScheduleDto): Observable<ResponseGetScheduleDto> {

    const method: string = 'POST';
    const func: string = 'getSchedule';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetScheduleDto>(method, url, params, urlParams, body);
  }

  public cancel(payload: RequestCancelDto): Observable<ResponseCancelDto> {

    const method: string = 'POST';
    const func: string = 'cancel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCancelDto>(method, url, params, urlParams, body);
  }

  public deleteDraft(payload: RequestDeleteDraftDto): Observable<ResponseDeleteDraftDto> {

    const method: string = 'POST';
    const func: string = 'deleteDraft';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteDraftDto>(method, url, params, urlParams, body);
  }

  public approve(payload: RequestApproveDto): Observable<ResponseApproveDto> {

    const method: string = 'POST';
    const func: string = 'approve';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseApproveDto>(method, url, params, urlParams, body);
  }

  public approveCancellation(payload: RequestApproveCancellationDto): Observable<ResponseApproveDto> {

    const method: string = 'POST';
    const func: string = 'approveCancellation';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseApproveDto>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-on-duty.api.ts